module.exports = __webpack_public_path__ + "static/media/adaptive_flow.41f30c36.png";